import React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface TopNavAction {
  icon: string;
  action: string;
}

interface TopNavProps {
  title: string;
  leftAction?: TopNavAction | null;
  rightAction?: TopNavAction | null;
  onActionClick?: (action: string) => void;
}

export function TopNav({ title, leftAction, rightAction, onActionClick }: TopNavProps) {
  const handleActionClick = (action: string) => {
    if (onActionClick) {
      onActionClick(action);
    } else {
      console.log(`Action clicked: ${action}`);
    }
  };

  const renderIcon = (iconName: string) => {
    // Using simple text icons for now - you can replace with proper icon library later
    const iconMap: Record<string, string> = {
      'arrow-left': '←',
      'bell': '🔔',
      'filter': '⚙️',
      'more-horizontal': '⋯',
      'settings': '⚙️',
    };
    
    return iconMap[iconName] || '•';
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between h-14 px-4 bg-background/95 backdrop-blur-sm border-b">
      <div className="flex items-center min-w-[44px]">
        {leftAction && (
          <Button 
            variant="ghost" 
            size="sm" 
            className="p-2"
            onClick={() => handleActionClick(leftAction.action)}
          >
            <span className="text-lg">{renderIcon(leftAction.icon)}</span>
          </Button>
        )}
      </div>
      
      <h1 className="font-semibold text-lg truncate text-center flex-1 px-2">
        {title}
      </h1>
      
      <div className="flex items-center min-w-[44px] justify-end">
        {rightAction && (
          <Button 
            variant="ghost" 
            size="sm" 
            className="p-2"
            onClick={() => handleActionClick(rightAction.action)}
          >
            <span className="text-lg">{renderIcon(rightAction.icon)}</span>
          </Button>
        )}
      </div>
    </header>
  );
}